/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2023 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';

export class option extends IceEntity {
  option_key = "";
  param_txt = "";
  param_value = "";
  record_version = 0;
  offline_record_status = 0;
  accessed = NaN;
  accessed_user = "";
  created = NaN;
  created_user = "";
  modified = NaN;
  modified_user = "";

  gettablename() {
    return "OPTION";
  };
}
